/**
 * Container class name builder for FlowchartView
 */

export function getContainerClasses({
  isPanning,
  isDragging,
  isConnecting,
  isSelectingBox,
  isFocusMode,
  isAnimatingIntoFocus,
  isAnimatingOutOfFocus,
  isAnimatingReorder,
  isAnimatingTidy,
  isAnimatingLayout,
  isAnimatingPan,
  isAnimatingFilter,
  isViewReady,
  hideEdgesAwaitingElk,
}) {
  const classes = ['flowchart'];
  
  if (isPanning) classes.push('flowchart--panning');
  if (isDragging) classes.push('flowchart--dragging');
  if (isConnecting) classes.push('flowchart--connecting');
  if (isSelectingBox) classes.push('flowchart--selecting');
  if (isFocusMode) classes.push('flowchart--focus-mode');
  if (isAnimatingIntoFocus) classes.push('flowchart--animating-focus-in');
  if (isAnimatingOutOfFocus) classes.push('flowchart--animating-focus-out');
  if (isAnimatingReorder) classes.push('flowchart--animating-reorder');
  if (isAnimatingTidy) classes.push('flowchart--animating-tidy');
  if (isAnimatingLayout) classes.push('flowchart--animating-layout');
  if (hideEdgesAwaitingElk) classes.push('flowchart--hide-edges-until-elk');
  if (isAnimatingPan) classes.push('flowchart--animating-pan');
  if (isAnimatingFilter) classes.push('flowchart--animating-filter');
  if (!isViewReady) classes.push('flowchart--initializing');
  
  // Combined flag: any animation is in progress
  // This blocks all pointer interactions to prevent drag/click during transitions
  const isAnimating = isAnimatingIntoFocus || isAnimatingOutOfFocus || 
                      isAnimatingReorder || isAnimatingTidy || isAnimatingLayout ||
                      isAnimatingPan || isAnimatingFilter;
  if (isAnimating) classes.push('flowchart--animating');
  
  return classes.join(' ');
}
